import ContactIdMappingModelBase from '../_generated/modelBases/contact-id-mapping-model-base';

export default class ContactIdMappingModel extends ContactIdMappingModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
